export interface TimeSpan {
    hours: number;
    minutes: number;
    seconds: number;
    milliseconds: number;
}

export function toTimeSpan(date: Date): TimeSpan {
    return {hours: date.getHours(), minutes: date.getMinutes(), seconds: date.getSeconds(), milliseconds: 0};
}

export function fromTimeSpan(ts: TimeSpan): Date {
    const date = new Date();
    date.setHours(ts.hours);
    date.setMinutes(ts.minutes);
    date.setSeconds(ts.seconds);
    date.setMilliseconds(ts.milliseconds);
    return date;
}
